export const QualitiesOptions: Array<IOption> = [
  {label: 'درجه یک', value: 'class_1'},
  {label: 'درجه دو', value: 'class_2'},
  {label: 'درجه سه', value: 'class_3'},
  {label: 'درجه چهار', value: 'class_4'},
];

export const wantedUnit: Array<IOption> = [
  {label: 'تن', value: 'ton'},
  {label: 'کیلوگرم', value: 'kilogram'},
  {label: 'گرم', value: 'gram'},
  {label: 'لیتر', value: 'liter'},
];
